import React from 'react';
import { TechnicalData as TD, NamingUtils } from '@zen/common-app-parts';
import { Box, themeUtils as tu } from '@zen-common/components-base';
import { numberUtils } from '@zen/common-utils';
import styled from 'styled-components';

export default function InnerTake({ isBuy, upToQuantity, initialPrice, base, quote, naming }) {
  return (
    <>
      <Box>
        <TD.Label>You may {isBuy ? 'sell' : 'buy'} up to:</TD.Label>
        <Box as="span" color={isBuy ? 'danger' : 'success'}>
          {numberUtils.toDisplay(upToQuantity)} {'      '}
        </Box>
        <Wrapper as="span">{NamingUtils.displayName(base, naming)}</Wrapper>
      </Box>
      <Box>
        <TD.Label>For a price per unit of:</TD.Label>
        <WrapperLabel as="span">{numberUtils.toDisplay(initialPrice)}</WrapperLabel>
        <Wrapper as="span">{NamingUtils.displayName(quote, naming)}</Wrapper>
      </Box>
    </>
  );
}

const Wrapper = styled(Box)`
  color: ${tu.color('text')};
  text-align: justify;
  margin-left: 10px;
)}
`;

const WrapperLabel = styled(Box)`
  color: ${tu.color('text')};
  text-align: justify;
)}
`;
